/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';

export const useCanOpenPooledAccount = () => {
    const CAN_OPEN_POOLED_ACCOUNT_GQL = gql`
    query CanOpenPooledAccount {
        canOpenPooledAccount {
            canOpenPooledAccount
        }
    }
    `;

    const { data, loading, error} = useQuery(CAN_OPEN_POOLED_ACCOUNT_GQL, {
        fetchPolicy: "network-only",
         context:{
            clientName:"/secure-storage/manage"
        }
    });
    
    return {event_check_data : data , loading, error};
}


export const useSecureStorageCustomerDetails = () => {
    const SECURE_STORAGE_CUS_DETAILS_GQL = gql`
    query SecureStorageCustomerDetails {
        secureStorageCustomerDetails {
            customerDetails {
                dateOfBirth
            }
        }
    }
    `;

    const { data, loading, error } = useQuery(SECURE_STORAGE_CUS_DETAILS_GQL, {
        fetchPolicy: "network-only",
         context:{
            clientName:"/secure-storage/manage"
        }
    });

    return {dob_data : data, loading, error };
}


export const useGetCustomerOccupation = () => {
    const GET_CUS_OCCUPATION_GQL = gql`
      query GetCustomerOccupation {
        getCustomerOccupation {
          customerOccupationDetails {
            occupation
          }
        }
      }
    `;   

    const { data, loading, error} = useQuery(GET_CUS_OCCUPATION_GQL, {
        fetchPolicy: "network-only",
         context:{
            clientName:"/secure-storage/manage"
        }
    });

    return {occupation_data : data, loading, error};
}